import styled from 'styled-components';

import { DEFAULT_COLORS } from 'constants/colors';

export const NavItemsStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    list-style: none;
    margin: 0;
    padding: 0;

    /* Focus styles for keyboard navigation */
    & > div:focus {
        outline: 2px solid ${DEFAULT_COLORS.LINK};
        outline-offset: 2px;
    }

    & > div:focus:not(:focus-visible) {
        outline: none;
    }

    & > div:focus-visible {
        outline: 2px solid ${DEFAULT_COLORS.LINK};
        outline-offset: 2px;
    }
`;
